import "./Card.scss";

const Card = ({ image, title, content }) => {
    const stringParts = content.split("\n");

    // Join the parts with <br /> elements
    const stringWithBreaks = stringParts.join("<br /><br />");
    return (
      <div className="card">
        <img className="card__image" src={image} alt="title" />
        <h3> {title}</h3>
        <p
          className="card__text"
          dangerouslySetInnerHTML={{ __html: stringWithBreaks }}
        >
        </p>
      </div>
    );
};

export default Card;
